'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindAll } from 'underscore';
import DropPositions from 'simple-menus-core/enums/DropPositions';
import * as MenuTreeActions from 'simple-menus-core/actions/MenuTree';
import { getMenuTreeNode } from 'simple-menus-core/selectors/menuTree';
import { jsx as _jsx } from "react/jsx-runtime";
function makeMapStateToProps() {
  return function mapStateToProps(state, props) {
    return {
      treeNode: getMenuTreeNode(state, props)
    };
  };
}
const mapDispatchToProps = {
  addNode: MenuTreeActions.addNode,
  moveNode: MenuTreeActions.moveNode,
  addChildNode: MenuTreeActions.addChildNode
};
const HOC = Component => {
  class WithConnectedMenuNodeDivider extends PureComponent {
    constructor(props) {
      super(props);
      bindAll(this, ['addNode', 'moveNode']);
    }
    addNode(type) {
      const {
        addNode,
        parentId,
        id,
        position,
        treeNode,
        addChildNode,
        menuId,
        isCollapsed
      } = this.props;
      if (treeNode.children.length && position === DropPositions.BOTTOM && !isCollapsed) {
        addChildNode(id, menuId, {
          type
        });
      } else {
        addNode(menuId, parentId, id, {
          type
        }, position);
      }
    }
    moveNode(node) {
      const {
        moveNode,
        parentId: targetParentId,
        id: targetId,
        position,
        menuId,
        treeNode,
        isCollapsed
      } = this.props;
      const {
        id: nodeId
      } = node;
      const dropPosition = treeNode.children.length && position === DropPositions.BOTTOM && !isCollapsed ? DropPositions.MIDDLE : position;
      moveNode(nodeId, targetId, targetParentId, dropPosition, menuId);
    }
    render() {
      const {
        id,
        depth,
        treeNode,
        isParentDragging,
        hasChildren,
        isLastChild,
        hasSibling,
        depthToNextSibling,
        hierarchy,
        menuId,
        moveNode: moveNodeAction,
        readOnly
      } = this.props;
      if (!treeNode) return null;
      return /*#__PURE__*/_jsx(Component, {
        id: id,
        depth: depth,
        addNode: this.addNode,
        moveNode: this.moveNode,
        isParentDragging: isParentDragging,
        hasChildren: hasChildren,
        isLastChild: isLastChild,
        hasSibling: hasSibling,
        depthToNextSibling: depthToNextSibling,
        hierarchy: hierarchy,
        menuId: menuId,
        moveNodeAction: moveNodeAction,
        readOnly: readOnly
      });
    }
  }
  WithConnectedMenuNodeDivider.defaultProps = {
    position: DropPositions.BOTTOM,
    hierarchy: []
  };
  WithConnectedMenuNodeDivider.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    depth: PropTypes.number.isRequired,
    position: PropTypes.oneOf([DropPositions.TOP, DropPositions.BOTTOM]).isRequired,
    addNode: PropTypes.func.isRequired,
    moveNode: PropTypes.func.isRequired,
    treeNode: PropTypes.object,
    addChildNode: PropTypes.func.isRequired,
    isParentDragging: PropTypes.bool,
    isLastChild: PropTypes.bool,
    hasChildren: PropTypes.bool,
    depthToNextSibling: PropTypes.number,
    hasSibling: PropTypes.bool,
    hierarchy: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
    isCollapsed: PropTypes.bool,
    readOnly: PropTypes.bool
  };
  return connect(makeMapStateToProps, mapDispatchToProps)(WithConnectedMenuNodeDivider);
};
export default function withConnectedMenuNodeDivider() {
  return HOC;
}